const Colors = {
  primary: "#E99E24",
};

export default Colors;
